<template>
  <div class="chat-container" :style="chatMessagesStyle">
    <!-- <v-btn
      v-if="!chatOpen"
      fab
      dark
      :style="headerStyle"
      class="floating-chat-button"
      elevation="8"
      @click="openChat"
    >
      <v-avatar size="40">
        <img v-if="useImageLogo" :src="chatLogoSrc" />
        <v-icon large v-else>{{ floatingIconName }}</v-icon>
      </v-avatar>
    </v-btn>
 -->
    <v-slide-x-reverse-transition>
      <v-card v-if="chatOpen" class="chat-panel rounded-xl elevation-8">
        <v-card-title class="chat-header pa-3" :style="headerStyle">
          <v-avatar size="36" class="ml-2">
            <img v-if="useImageLogo" :src="chatLogoSrc" alt="logo" />
            <v-icon v-else color="white">{{ floatingIconName }}</v-icon>
          </v-avatar>
          <div class="flex-grow-1 text-right">
            <div class="text-subtitle-1 font-weight-bold">
              {{ aiChatConfig?.assistant?.name || "دستیار هوشمند" }}
            </div>
            <v-chip x-small color="success" dark class="mt-n1">
              <v-icon x-small right class="ml-1">mdi-circle</v-icon>
              آنلاین
            </v-chip>
          </div>
          <v-spacer />

          <!-- <v-btn icon small @click="newChat" color="white" title="گفتگوی جدید">
            <v-icon small>mdi-message-plus</v-icon>
          </v-btn> -->
          <v-btn
            icon
            small
            @click="clearChat"
            color="white"
            title="پاک کردن گفتگو"
          >
            <v-icon small>mdi-trash-can-outline</v-icon>
          </v-btn>
          <!-- <v-btn
            icon
            small
            @click="chatOpen = false"
            color="white"
            title="بستن"
          >
            <v-icon small>mdi-close</v-icon>
          </v-btn> -->
        </v-card-title>

        <v-divider />
        <v-card-text ref="chatContainer" class="chat-messages pa-3">
          <div v-if="messages.length === 0" class="text-center py-6">
            <v-avatar size="50">
              <v-icon v-if="!useImageLogo" size="48" color="grey lighten-1"
                >mdi-robot</v-icon
              >
              <v-icon v-else size="48" color="grey lighten-1">{{
                floatingIconName
              }}</v-icon>
            </v-avatar>
            <div class="grey--text text--lighten-1 mt-2">
              چطور می‌توانم به شما کمک کنم؟
            </div>
          </div>

          <div
            v-for="(message, index) in messages"
            :key="index"
            :class="[
              'message-wrapper mb-3 d-flex',
              message.role !== 'user' ? 'justify-start' : 'justify-end',
            ]"
          >
            <div
              :class="[
                'message-bubble pa-3 rounded-lg',
                message.role === 'user' ? 'user-message' : 'assistant-message',
              ]"
              :style="
                message.role === 'user'
                  ? userMessageStyle
                  : assistantMessageStyle
              "
              style="max-width: 85%"
            >
              <div
                v-if="message.role === 'assistant'"
                class="d-flex align-center mb-1"
              >
                <v-avatar size="24" class="ml-1">
                  <img v-if="useImageLogo" :src="chatLogoSrc" alt="logo" />
                  <v-icon v-else :style="headerStyle" x-small>{{
                    floatingIconName
                  }}</v-icon>
                </v-avatar>
                <span class="mr-1 text-caption font-weight-bold">دستیار</span>
              </div>

              <div
                class="message-content text-body-2"
                v-html="
                  formatMessage(
                    index === messages.length - 1 &&
                      message.role === 'assistant' &&
                      isTyping
                      ? typingText
                      : message.content,
                  )
                "
              ></div>

              <span
                v-if="
                  index === messages.length - 1 &&
                  message.role === 'assistant' &&
                  isTyping
                "
                class="typing-cursor"
                >|</span
              >

              <div v-if="message.showUpgradeButton && !isTyping" class="mt-2">
                <v-btn
                  x-small
                  outlined
                  color="primary"
                  @click="openUpgradeDialog"
                >
                  <v-icon right x-small class="ml-1">mdi-autorenew</v-icon>
                  ارتقا سرویس / تلاش مجدد
                </v-btn>
              </div>

              <div
                class="message-time text-caption mt-1 grey--text text--lighten-1 text-left"
              >
                {{ formatTime(message.timestamp) }}
              </div>
            </div>
          </div>

          <div v-if="loading" class="d-flex align-center justify-start mb-3">
            <v-progress-circular
              indeterminate
              size="18"
              width="2"
              color="primary"
              class="ml-2"
            />
            <span class="text-caption grey--text">در حال پاسخگویی...</span>
          </div>
        </v-card-text>

        <v-divider />

        <v-card-actions class="chat-input pa-2">
          <v-textarea
            v-model="userMessage"
            placeholder="پیام خود را بنویسید..."
            rows="1"
            auto-grow
            outlined
            dense
            hide-details
            class="rounded-lg ml-2"
            @keydown.enter.exact.prevent="sendMessage"
          />
          <v-btn
            :disabled="!userMessage.trim() || loading"
            :loading="loading"
            :style="headerStyle"
            fab
            small
            dark
            @click="sendMessage"
          >
            <v-icon small style="transform: rotate(180deg)">mdi-send</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-slide-x-reverse-transition>
  </div>
</template>

<script>
export default {
  name: "AssistantChatViewer",

  props: {
    value: Object,
  },

  computed: {
    aiChatConfig: {
      get() {
        return this.value || {};
      },
      set(newVal) {
        this.$emit("input", newVal);
      },
    },
    chatSettings() {
      return this.aiChatConfig?.chatSettings || {};
    },

    headerStyle() {
      const settings = this.chatSettings;
      let background = settings.headerColor || "#667eea";
      if (settings.headerGradient && settings.headerColor2) {
        background = `linear-gradient(135deg, ${settings.headerColor} 0%, ${settings.headerColor2} 100%)`;
      }
      return { background, color: "white" };
    },
    chatBodyStyle() {
      const s = this.chatSettings;
      if (s.useImageBackground && s.backgroundImage) {
        return {
          backgroundImage: `url(${s.backgroundImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        };
      }
      return {
        background: s.backGradient
          ? `linear-gradient(135deg, ${s.backColor} 0%, ${s.backColor2} 100%)`
          : s.backColor || "#fafafa",
      };
    },
    chatMessagesStyle() {
      console.log(this.chatSettings, "settings");
      const settings = this.chatSettings;
      if (settings.useImageBackground && settings.backgroundImage) {
        return {
          backgroundImage: `url(${settings.backgroundImage}) !important`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        };
      }

      return {
        background: settings.backGradient
          ? `linear-gradient(135deg, ${settings.backColor} 0%, ${settings.backColor2} 100%)`
          : settings.backColor || "#fafafa",
      };
    },

    userMessageStyle() {
      const settings = this.chatSettings;
      let background = settings.headerColor || "#667eea";
      if (settings.headerGradient && settings.headerColor2) {
        background = `linear-gradient(135deg, ${settings.headerColor} 0%, ${settings.headerColor2} 100%)`;
      }
      return { background, color: "white" };
    },

    assistantMessageStyle() {
      const settings = this.chatSettings;
      return {
        color: settings.textColor || "#333333",
        fontSize: `${settings.fontSize || 14}px`,
        direction: "rtl",
      };
    },

    floatingIconName() {
      return this.chatSettings.floatingIcon || "mdi-robot";
    },

    chatLogoSrc() {
      return this.chatSettings.chatLogo;
    },

    useImageLogo() {
      return this.chatSettings.useImageLogo && this.chatLogoSrc;
    },
  },

  data() {
    return {
      isPageLoading: true,
      typingStopped: false,
      typingText: "",
      isTyping: false,
      typingTimeout: null,
      chatOpen: true,
      messages: [],
      userMessage: "",
      loading: false,
      previse_messages: [],
      showUpgradeButton: false,
      showUpgradeDialog: false,
    };
  },

  beforeDestroy() {
    if (this.typingTimeout) clearTimeout(this.typingTimeout);
  },
  watch: {
    "aiChatConfig.chatSettings": {
      handler() {
        this.$forceUpdate();
      },
      deep: true,
    },
  },
  methods: {
    typeText(fullText) {
      if (!fullText) {
        this.isTyping = false;
        return;
      }
      if (this.typingTimeout) clearTimeout(this.typingTimeout);

      this.isTyping = true;
      this.typeText = ""; //new
      this.typingStoppted = false;
      let currentIndex = 0;
      const speed = 30;

      const typeNextChar = () => {
        if (this.typingStopped) return;

        if (currentIndex < fullText.length) {
          this.typingText = fullText.substring(0, currentIndex + 1);
          currentIndex++;
          this.typingTimeout = setTimeout(typeNextChar, speed);
          this.$nextTick(() => this.scrollToBottom());
        } else {
          this.isTyping = false;
        }
      };
      typeNextChar();
    },

    // openChat() {
    //   this.chatOpen = true;
    //   this.scrollToBottom();
    // },

    async sendMessage() {
      if (!this.userMessage.trim() || this.loading) return;

      const userMsg = this.userMessage.trim();
      this.userMessage = "";
      this.messages.push({
        role: "user",
        content: userMsg,
        timestamp: new Date(),
      });

      this.loading = true;
      this.scrollToBottom();
      this.showUpgradeButton = false;

      try {
        setTimeout(() => {
          const response = "این یک پاسخ تست از طرف دستیار هوشمند است.";
          this.messages.push({
            role: "assistant",
            content: response,
            timestamp: new Date(),
          });
          this.typeText(response);
          this.loading = false;
        }, 1000);
      } catch (error) {
        const errorMsg = "متأسفانه خطایی در برقراری ارتباط رخ داد.";
        this.messages.push({
          role: "assistant",
          content: errorMsg,
          timestamp: new Date(),
          showUpgradeButton: true,
        });
        this.typeText(errorMsg);
        this.loading = false;
      }
    },

    newChat() {
      // استفاده از تاییدیه فارسی به جای $t
      if (
        confirm(
          "آیا مایل به شروع یک گفتگوی جدید هستید؟ پیام‌های قبلی پاک خواهند شد.",
        )
      ) {
        this.clearChat();
      }
    },

    clearChat() {
      if (this.typingTimeout) clearTimeout(this.typingTimeout);
      this.messages = [];
      this.userMessage = "";
      this.previse_messages = [];
      this.isTyping = false;
    },

    scrollToBottom() {
      this.$nextTick(() => {
        if (this.$refs.chatContainer) {
          this.$refs.chatContainer.scrollTop =
            this.$refs.chatContainer.scrollHeight;
        }
      });
    },

    formatMessage(content) {
      return content ? content.replace(/\n/g, "<br>") : "";
    },

    formatTime(timestamp) {
      return new Date(timestamp).toLocaleTimeString("fa-IR", {
        hour: "2-digit",
        minute: "2-digit",
      });
    },
    cancelRequest() {
      this.loading = false;
      this.isTyping = false;
      this.typingStopped = false;
      if (this.typingTimeout) {
        clearTimeout(this.typingTimeout);
        this.typingTimeout = null;
      }
      const lastIndex = this.messages.length - 1;
      if (lastIndex < 0) return;
      const lastMsg = this.messages[lastIndex];
      if (lastMsg.role === "assistant") {
        const partial = this.typingText.trim();
        this.$set(
          lastMsg,
          "content",
          partial ? partial + " [متوقف شد]" : "پاسخ متوقف شد.",
        );
      }
      this.typingText = "";
      this.$nextTick(() => this.scrollToBottom());
    },
    openUpgradeDialog() {
      this.showUpgradeDialog = true;
      // منطق باز شدن دیالوگ ارتقا
    },
  },
};
</script>

<style scoped>
.chat-container {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
  z-index: 4;
  direction: rtl;
}

.floating-chat-button {
  position: absolute !important;
  z-index: 5;
  animation: pulse 2s infinite;
  bottom: 20px !important;
  right: 20px !important;
  pointer-events: auto;
}

.chat-panel {
  position: absolute !important;
  bottom: 80px;
  right: 20px;
  width: 350px;
  max-width: calc(100vw - 40px);
  max-height: 500px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  pointer-events: auto;
  z-index: 5;
  direction: rtl;
  background: transparent !important;
  /* background: red !important; */
}

.chat-header {
  color: white;
  flex-shrink: 0;
}

.chat-messages {
  direction: ltr !important;
  flex: 1;
  overflow-y: auto;
  min-height: 200px;
  /* background-color: #f5f5f5; */
  background: transparent !important;
  /* تایید رنگ */
  /* background: red !important; */
}
.chat-messages::-webkit-scrollbar-thumb:hover {
  background: #555;
}
.chat-messages::-webkit-scrollbar-thumb {
  background: var(--tail-color);
  border-radius: 10px;
}
.chat-messages::-webkit-scrollbar {
  width: 6px;
}
.user-message {
  background-color: #e3f2fd;
  border-radius: 16px 16px 4px 16px !important;
  text-align: right;
}

.assistant-message {
  background: #fff;
  border-radius: 16px 16px 16px 4px !important;
  border: 1px solid #e0e0e0;
  text-align: right;
}
.assistant-message::before,
.user-message::before {
  background: var(--tail-color) !important;
}
.typing-cursor {
  display: inline-block;
  animation: blink 1s infinite;
  font-weight: bold;
  margin-right: 2px;
}

@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(102, 126, 234, 0.7);
  }
  70% {
    box-shadow: 0 0 0 10px rgba(102, 126, 234, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(102, 126, 234, 0);
  }
}

@keyframes blink {
  0%,
  50% {
    opacity: 1;
  }
  51%,
  100% {
    opacity: 0;
  }
}

:deep(.v-input__control) {
  background: white !important;
}
.preloader-overlay {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}
.pulse-wave {
  animation: pulseWave 1.8s ease-in-out infinite;
  box-shadow: 0 0 0 0 var(--pulse-color);
}
@keyframes pulseWave {
  0% {
    transform: scale(0.8);
    box-shadow: 0 0 0 0 var(--pulse-color);
  }
  70% {
    transform: scale(1.1);
    box-shadow: 0 0 0 25px transparent;
  }
  100% {
    transform: scale(0.8);
  }
}
.chat-input {
  backdrop-filter: brightness(0.9) blur(10px) !important;
  padding-top: 15px !important;
  border-top: 1px solid #e0e0e0;
  flex-shrink: 0;
  min-height: 80px;
}
</style>
